/*
 * @Author       : LiYang
 * @Date         : 2021-08-25 20:34:08
 * @LastEditTime: 2022-01-29 14:42:17
 * @LastEditors: Please set LastEditors
 * @Description  :
 */
const encodeReserveRE = /[!'()*]/g
const encodeReserveReplacer = c => '%' + c.charCodeAt(0).toString(16)
const commaRE = /%2C/g
import mpx from '@mpxjs/core'

export * from './lib/date'
export * from './lib/functional'
export * from './lib/type'
export * from './lib/eError'
export * from './lib/gps'

export { default as classNames } from './lib/classNames'
export { default as toPromise } from './lib/toPromise'

import copy from 'copy-text-to-clipboard'
 
export function encode (str) {
  return (
    encodeURIComponent(str)
      .replace(encodeReserveRE, encodeReserveReplacer)
      .replace(commaRE, ',')
  )
}

export function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    console.log(err)
  }
  return str
}

export function parseQuery (query) {
  const res = {}

  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }

  query.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : null

    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = [res[key], val]
    }
  })

  return res
}

export function stringifyQuery (obj) {
  const res = obj
    ? Object.keys(obj)
      .map(key => {
        const val = obj[key]

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          const result = []
          val.forEach(val2 => {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key))
            } else {
              result.push(encode(key) + '=' + encode(val2))
            }
          })
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(x => x.length > 0)
      .join('&')
    : null
  return res ? `?${res}` : ''
}

/**
 * 
 * @param {string} data - 要脱敏的数据
 * @param {number} star - 开始索引
 * @param {number} end - 截止索引
 * @returns { string } - 脱敏后的数据
 */
export function desensitize (data, star = 0, end = data.length) {
  if (end < 0) {
    end = end + data.length;
  }
  const len = Math.abs(end - star);
  return data.substring(0, star) + '*'.repeat(len) + data.substring(end);
}

/**
 * 处理电话格式
 * @param {*} inputPhone 
 * @returns 
 */
 export function handlePhone(inputPhone) {
  const phone = inputPhone
  if (
    (phone.slice(0, 3) === '400' || phone.slice(0, 3) === '800') &&
    phone.split('-').length === 4
  ) {
    const phoneArr = phone.split('-')
    return phoneArr[0] + phoneArr[1] + phoneArr[2] + ',' + phoneArr[3]
  } else if (
    (phone.slice(0, 3) === '400' || phone.slice(0, 3) === '800') &&
    phone.split('-').length === 3
  ) {
    const phoneArr = phone.split('-')
    return phoneArr[0] + phoneArr[1] + phoneArr[2]
  } else if (phone.indexOf(',') > -1) {
    const phoneArr = phone.split(',')
    return phoneArr[0]
  } else if (phone.indexOf('-') > -1 && phone.split('-').length === 3) {
    const phoneArr = phone.split('-')
    return phoneArr[0] + phoneArr[1] + ',' + phoneArr[2]
  } else {
    return phone.replace('-', '')
  }
}

/**
 * 设置剪贴板，mpx.setClipboardData()不支持h5
 * @param {object} options - 参数
 * @property {string} params.data  - 剪贴板文案
 * @property {function} params.success - 成功回调
 * @property {function} params.fail - 失败回调
 * @returns {promise}
 */
 export function setClipboardData(options) {
  if (__mpx_mode__ === 'dd') {
    return mpx.setClipboardData({...options, disableToast: true,})
  } else {
    try {
      copy(options.data)
      options.success && options.success()
    } catch (err) {
      if (options.fail) {
        options.fail(err)
      } else {
        mpx.showToast({icon: 'none', title: '暂不支持复制'})
      }
    }
  }
}